// Exact text extracted from RESQLY – PRIVACY POLICY PDF (DOC-20260423-WA0001..pdf).
export const PRIVACY_PDF_PAGES = [
  `India-compliant Privacy Policy. It’s structured for healthcare + platform use cases and aligned
with Indian laws (IT Act, SPDI Rules) and modern practices under the Digital Persona



RESQLY – PRIVACY POLICY



   1.\u200b Introduction

This Privacy Policy describes how Resqly (“Platform”, “we”, “us”, or “our”) collects, uses, stores,
and protects personal data of users and service providers.

By using the Resqly application, you agree to the collection and use of information in
accordance with this Privacy Policy.



   2.\u200b Applicability

This Policy applies to:

   ●\u200b Users (patients, customers, pet owners)
   ●\u200b Service Providers (doctors, pharmacies, nurses, labs, pet care providers)



   3.\u200b Legal Framework

This Privacy Policy is aligned with applicable Indian laws, including:

   ●\u200b Information Technology Act, 2000
   ●\u200b IT (Reasonable Security Practices and Procedures and Sensitive Personal Data or
      Information) Rules, 2011
   ●\u200b Digital Personal Data Protection Act, 2023 (as applicable)



   4.\u200b Information We Collect

4.1 Personal Information

   ●\u200b   Name
   ●\u200b   Phone number
   ●\u200b   Email address
   ●\u200b   Location details`,
  `   ●\u200b Profile details



4.2 Sensitive Personal Data (SPDI)

Where applicable, we may collect:

   ●\u200b   Health-related information
   ●\u200b   Medical history (if provided)
   ●\u200b   Prescriptions
   ●\u200b   Consultation details

This information is collected only with user consent and for service delivery.



4.3 Provider Information

For service providers, we collect:

   ●\u200b   Professional details
   ●\u200b   Licenses and certifications
   ●\u200b   Identity documents
   ●\u200b   Bank/payment details



4.4 Device and Usage Data

   ●\u200b   IP address
   ●\u200b   Device type
   ●\u200b   App usage data
   ●\u200b   Log information



   5.\u200b Purpose of Data Collection

We collect and use data for:

   ●\u200b   Connecting users with service providers
   ●\u200b   Processing bookings and requests
   ●\u200b   Facilitating consultations and services
   ●\u200b   Processing payments
   ●\u200b   Customer support and communication
   ●\u200b   Improving platform functionality`,
  `   6.\u200b Consent

By using the platform, you provide consent for:

   ●\u200b Collection and processing of personal data
   ●\u200b Sharing of data with service providers for service fulfillment

Users may withdraw consent by contacting us, subject to legal and operational limitations.



   7.\u200b Data Sharing

We may share data with:

   ●\u200b Service providers (doctors, pharmacies, etc.)
   ●\u200b Payment gateway providers
   ●\u200b Technical service providers

We do not sell personal data to third parties.



   8.\u200b Data Storage and Security

We implement reasonable security practices as required under Indian law, including:

   ●\u200b Encryption (where applicable)
   ●\u200b Secure servers
   ●\u200b Access control measures

However, no system is completely secure, and users acknowledge this risk.



   9.\u200b Data Retention

We retain personal data:

   ●\u200b As long as necessary for service delivery
   ●\u200b To comply with legal obligations
   ●\u200b To resolve disputes

Users may request deletion of their data, subject to applicable laws.`,
  `   10.\u200bUser Rights

Under applicable laws, users have the right to:

   ●\u200b   Access their data
   ●\u200b   Correct inaccurate data
   ●\u200b   Withdraw consent
   ●\u200b   Request deletion (subject to legal requirements)

Requests can be made via contact details below.



   11.\u200bChildren’s Privacy

The platform is not intended for use by minors without parental consent.\u200b
We do not knowingly collect data from children.



   12.\u200bCookies and Tracking

We may use cookies or similar technologies to:

   ●\u200b Improve user experience
   ●\u200b Analyze usage patterns

Users can control cookies through device settings.



   13.\u200bThird-Party Links

The platform may contain links to third-party services.\u200b
We are not responsible for their privacy practices.



   14.\u200bChanges to Privacy Policy

We may update this Privacy Policy from time to time.\u200b
Users will be notified of significant changes.



   15.\u200bGrievance Officer

In accordance with Indian law, the contact details of the Grievance Officer are:`,
  `Name: [To be updated]\u200b
Email: support@resqly.com



   16.\u200bContact

For any privacy-related queries:

Email: support@resqly.com



   17.\u200bAcknowledgment

By using Resqly, you acknowledge that you have read and understood this Privacy Policy and
agree to its terms.`
];
